// src/components/CampaignWorkflowTable.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getWorkflows, toggleWorkflow, deleteWorkflow } from '../services/workflowService';
import './CampaignWorkflowTable.css';

const CampaignWorkflowTable = ({ campaignId }) => {
    const [workflows, setWorkflows] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchWorkflows = async () => {
        try {
            const response = await getWorkflows(campaignId);
            setWorkflows(response.data.workflows);
        } catch (error) {
            console.error('Error fetching workflows:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWorkflows();
    }, [campaignId]);

    const handleToggleWorkflow = async (workflowId, currentState) => {
        try {
            await toggleWorkflow(workflowId, !currentState);
            fetchWorkflows(); // Refresh the list
        } catch (error) {
            console.error('Error toggling workflow:', error);
        }
    };

    const handleEditWorkflow = (workflowId) => {
        navigate(`/workflow-builder/${workflowId}`);
    };

    const handleDeleteWorkflow = async (workflowId) => {
        if (window.confirm('Are you sure you want to delete this workflow?')) {
            try {
                await deleteWorkflow(workflowId);
                fetchWorkflows(); // Refresh the list
            } catch (error) {
                console.error('Error deleting workflow:', error);
            }
        }
    };

    if (loading) {
        return <p>Loading workflows...</p>;
    }

    return (
        <div className="workflow-table-container">
            <div className="workflow-header">
                <h3>Workflows for this Campaign</h3>
                <button
                    className="create-workflow-btn"
                    onClick={() => navigate(`/workflow-builder/new?campaignId=${campaignId}`)}
                >
                    Create New Workflow
                </button>
            </div>

            <table className="workflow-table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Created</th>
                    <th>Last Modified</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {workflows.length === 0 ? (
                    <tr>
                        <td colSpan="5" style={{ textAlign: 'center' }}>
                            No workflows found for this campaign.
                        </td>
                    </tr>
                ) : (
                    workflows.map((workflow) => (
                        <tr key={workflow.id}>
                            <td>{workflow.name}</td>
                            <td>{new Date(workflow.createdAt).toLocaleDateString()}</td>
                            <td>{new Date(workflow.updatedAt).toLocaleDateString()}</td>
                            <td>
                                <div className="toggle-container">
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={workflow.isEnabled}
                                            onChange={() => handleToggleWorkflow(workflow.id, workflow.isEnabled)}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                    <span className="status-text">
                                            {workflow.isEnabled ? 'Enabled' : 'Disabled'}
                                        </span>
                                </div>
                            </td>
                            <td>
                                <button
                                    className="edit-btn"
                                    onClick={() => handleEditWorkflow(workflow.id)}
                                >
                                    Edit
                                </button>
                                <button
                                    className="delete-btn"
                                    onClick={() => handleDeleteWorkflow(workflow.id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))
                )}
                </tbody>
            </table>
        </div>
    );
};

export default CampaignWorkflowTable;